export const ONLINE_LOAN_APPLICATION_URL = 'https://www.sravni.ru/kredity/onlajn-zayavka-na-kredit/';
